function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ApolloLink, Observable } from '@apollo/client';
export default function createAbortNetworkFetchLink() {
    return new ApolloLink(function abortNetworkFetchLink(operation, forward) {
        let controller = new AbortController();
        operation.setContext(({ fetchOptions = {} })=>({
                fetchOptions: _object_spread_props(_object_spread({}, fetchOptions), {
                    signal: controller === null || controller === void 0 ? void 0 : controller.signal
                })
            }));
        return new Observable((observer)=>{
            const subscription = forward(operation).subscribe({
                next: function abortLinkNext(result) {
                    return observer.next(result);
                },
                error: function abortLinkError(error) {
                    controller = null;
                    return observer.error(error);
                },
                complete: function abortCompleteError() {
                    controller = null;
                    return observer.complete();
                }
            });
            return function abortNetworkFetchLinkUnsubscribe() {
                if (controller) {
                    controller.abort();
                }
                subscription.unsubscribe();
            };
        });
    });
}

//# sourceMappingURL=createAbortNetworkFetchLink.js.map